'use client'

import { useState } from 'react'
import {
  Paper,
  Box,
  Button,
  Typography,
  TextField,
  Grid,
  Divider
} from '@material-ui/core'
import { Add, Remove } from '@material-ui/icons'
import { getDescriptor } from 'views/utils/functions'
import StatusLegend from '../components/StatusLegend'

export default function ControlPanel({
  rows,
  columns,
  columnDescriptor,
  rowDescriptor,
  addRow,
  removeRow,
  addColumn,
  removeColumn,
  selectedStatus,
  setSelectedStatus,
  updateRowStatus,
  updateColumnStatus,
  statusCounts
}) {
  const [selectedRow, setSelectedRow] = useState(1)
  const [selectedColumn, setSelectedColumn] = useState(1)

  const handleRowChange = (event) => {
    setSelectedRow(Number(event.target.value))
  }

  const handleColumnChange = (event) => {
    setSelectedColumn(Number(event.target.value))
  }

  const applyToRow = () => {
    updateRowStatus(selectedRow, selectedStatus)
  }

  const applyToColumn = () => {
    updateColumnStatus(selectedColumn, selectedStatus)
  }

  const isInRange = (value, max) => value >= 1 && value <= max

  return (
    <Paper elevation={0} sx={{ mb: 3, boxShadow: 'none', border: 'none' }}>
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          md={6}
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column'
          }}>
          <Typography variant='h6' gutterBottom>
            Dimensiones
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 16 }}>
            <Typography sx={{ mr: 2 }} style={{ minWidth: 100 }}>
              Filas:&nbsp;
              <Typography variant='span' style={{ fontWeight: 'bold' }}>
                {rows}
              </Typography>
            </Typography>
            <Button
              variant='outlined'
              size='small'
              onClick={addRow}
              startIcon={<Add />}
              disabled={rows >= 90}
              sx={{ mr: 1 }}>
              Agregar
            </Button>
            <Button
              variant='outlined'
              size='small'
              onClick={removeRow}
              startIcon={<Remove />}
              disabled={rows <= 1}>
              Quitar
            </Button>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 16 }}>
            <Typography sx={{ mr: 2 }} style={{ minWidth: 100 }}>
              Columnas:&nbsp;
              <Typography variant='span' style={{ fontWeight: 'bold' }}>
                {columns}
              </Typography>
            </Typography>
            <Button
              variant='outlined'
              size='small'
              onClick={addColumn}
              startIcon={<Add />}
              disabled={columns >= 90}
              sx={{ mr: 1 }}>
              Agregar
            </Button>
            <Button
              variant='outlined'
              size='small'
              onClick={removeColumn}
              startIcon={<Remove />}
              disabled={columns <= 1}>
              Quitar
            </Button>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <StatusLegend
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            statusCounts={statusCounts}
          />
        </Grid>

        <Grid item xs={12}>
          <Divider sx={{ my: 2 }} />
          <Typography variant='h6' style={{ marginBlock: 16 }}>
            Aplicar Estado por Fila/Columna
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: 16,
                  gap: 2
                }}>
                <TextField
                  style={{ width: 160 }}
                  label='Número de Fila'
                  type='number'
                  value={selectedRow}
                  onChange={handleRowChange}
                  InputProps={{ inputProps: { min: 1, max: rows } }}
                  size='small'
                />
                <Button
                  variant='contained'
                  style={{ marginLeft: 8, textTransform: 'none' }}
                  disabled={!isInRange(selectedRow, rows)}
                  onClick={applyToRow}>
                  {`Aplicar a Fila ${selectedRow <= rows ? getDescriptor(rowDescriptor, selectedRow) : ''}`}
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: 16,
                  gap: 2
                }}>
                <TextField
                  style={{ width: 160 }}
                  label='Número de Columna'
                  type='number'
                  value={selectedColumn}
                  onChange={handleColumnChange}
                  InputProps={{ inputProps: { min: 1, max: columns } }}
                  size='small'
                />
                <Button
                  variant='contained'
                  style={{ marginLeft: 8, textTransform: 'none' }}
                  disabled={!isInRange(selectedColumn, columns)}
                  onClick={applyToColumn}>
                  {`Aplicar a Columna ${isInRange(selectedColumn, columns) ? getDescriptor(columnDescriptor, selectedColumn) : ''}`}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  )
}
